import { geoProjection } from 'd3-geo'

export const MAP_WIDTH = 1440
export const MAP_HEIGHT = 748

// The Figma map uses an equirectangular outline stretched vertically. The same stretch is kept
// for the world view: 360° of longitude fill the 1440px width and 83.6°N–55.6°S fit the height.
const horizontalScale = MAP_WIDTH / (2 * Math.PI)
const verticalStretch = 579.1 / 468.8
const rawProjection = Object.assign(
  (longitude: number, latitude: number): [number, number] => [
    longitude,
    latitude * verticalStretch,
  ],
  {
    invert: (x: number, y: number): [number, number] => [x, y / verticalStretch],
  }
)

export const worldProjection = geoProjection(rawProjection)
  .scale(horizontalScale)
  .translate([MAP_WIDTH / 2, 433])

export const DEFAULT_MAP_CENTER = worldProjection.invert?.([MAP_WIDTH / 2, MAP_HEIGHT / 2]) as [
  number,
  number,
]
